import { useCallback, useEffect, useState } from 'react';
import type { Cliente, NuevoClienteDraft } from '../types';
import { storage } from '../lib/storage';
import { nuevoUUID } from '../lib/uuid';
import { encolar } from '../lib/outbox';
import { onDatosCambiados } from '../lib/events';

export function useClientes() {
  const [clientes, setClientes] = useState<Cliente[]>([]);
  const [cargando, setCargando] = useState(true);

  const recargar = useCallback(async () => {
    const lista = await storage.obtenerClientes();
    setClientes(lista);
  }, []);

  useEffect(() => {
    void (async () => {
      await recargar();
      setCargando(false);
    })();
    return onDatosCambiados(() => {
      void recargar();
    });
  }, [recargar]);

  const agregarCliente = useCallback(
    async (draft: NuevoClienteDraft): Promise<Cliente> => {
      const ahora = new Date().toISOString();
      const cliente: Cliente = {
        id: nuevoUUID(),
        nombre: draft.nombre,
        telefono: draft.telefono,
        email: draft.email,
        notas: draft.notas,
        creado: ahora,
        updatedAt: ahora,
        deletedAt: null,
      };
      await storage.guardarCliente(cliente);
      await encolar({
        entity: 'cliente',
        id: cliente.id,
        type: 'create',
        data: {
          nombre: cliente.nombre,
          telefono: cliente.telefono,
          email: cliente.email,
          notas: cliente.notas,
        },
        clientUpdatedAt: ahora,
      });
      await recargar();
      return cliente;
    },
    [recargar]
  );

  const buscarClientes = useCallback(
    (texto: string): Cliente[] => {
      if (texto.length < 2) return [];
      const lower = texto.toLowerCase();
      return clientes.filter(
        (c) => c.nombre.toLowerCase().includes(lower) || (c.telefono && c.telefono.includes(texto))
      );
    },
    [clientes]
  );

  return { clientes, cargando, agregarCliente, buscarClientes };
}
